import { motion } from "framer-motion";
import Particles from "./Particles";
import { MaskedLine, Reveal, EASE } from "./Reveal";

function YogiSilhouette() {
    return (
        <svg viewBox="0 0 400 260" className="h-auto w-[min(420px,72vw)]" aria-hidden="true">
            <defs>
                <linearGradient id="rim" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="rgba(245,197,66,0.55)" />
                    <stop offset="1" stopColor="rgba(245,197,66,0.05)" />
                </linearGradient>
            </defs>
            <g fill="#020202" stroke="url(#rim)" strokeWidth="1.6">
                <circle cx="200" cy="74" r="21" />
                <path d="M172 106 Q200 92 228 106 L236 178 Q200 190 164 178 Z" />
                <path d="M176 118 Q140 160 122 196 L138 204 Q162 172 184 148 Z" />
                <path d="M224 118 Q260 160 278 196 L262 204 Q238 172 216 148 Z" />
                <ellipse cx="200" cy="204" rx="92" ry="26" />
                <ellipse cx="146" cy="196" rx="30" ry="12" />
                <ellipse cx="254" cy="196" rx="30" ry="12" />
            </g>
        </svg>
    );
}

export default function Philosophy() {
    return (
        <section
            data-testid="philosophy-section"
            className="relative overflow-hidden py-28 sm:py-36 lg:py-44"
        >
            {/* sunrise */}
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute inset-x-0 bottom-0 h-[70%] bg-[radial-gradient(ellipse_at_50%_115%,rgba(232,137,22,0.28),rgba(212,160,23,0.1)_45%,transparent_72%)]" />
                <div className="absolute inset-x-0 bottom-0 h-[70%] bg-[radial-gradient(ellipse_at_50%_115%,rgba(245,197,66,0.14),transparent_55%)]" />
            </div>
            <Particles className="absolute inset-0 h-full w-full opacity-70" density={22000} />

            <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center px-4 text-center sm:px-8">
                <Reveal y={20}>
                    <p className="text-[11px] font-bold uppercase tracking-[0.4em] text-[#E88916]">
                        The Philosophy
                    </p>
                </Reveal>

                <blockquote className="mt-9 font-display leading-[1.06]">
                    <MaskedLine
                        delay={0.1}
                        className="text-[clamp(1.5rem,7vw,4.5rem)] tracking-wide text-white/90"
                    >
                        DISCIPLINE BUILDS THE BODY.
                    </MaskedLine>
                    <MaskedLine
                        delay={0.28}
                        className="text-[clamp(1.5rem,7vw,4.5rem)] tracking-wide text-white/90"
                    >
                        FOCUS BUILDS THE MIND.
                    </MaskedLine>
                    <MaskedLine
                        delay={0.46}
                        className="text-gold-grad text-[clamp(1.5rem,7vw,4.5rem)] tracking-wide"
                    >
                        PRACTICE BUILDS THE CHAMPION.
                    </MaskedLine>
                </blockquote>

                <Reveal delay={0.6} y={16}>
                    <p className="mt-8 text-[11px] font-bold uppercase tracking-[0.35em] text-[#B8B8B8]">
                        — Trainer Aryan
                    </p>
                </Reveal>

                <motion.div
                    className="mt-10"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 1.1, delay: 0.5, ease: EASE }}
                >
                    <YogiSilhouette />
                </motion.div>
            </div>
        </section>
    );
}
